import { createContext, PropsWithChildren, useState } from "react";
import { useWizard } from "components/elements/Wizard/useWizard";
import { IssueModel } from "../types/IssueModel";
import Wizard from "components/elements/Wizard/Wizard";

export function IssueCreateProvider(p: PropsWithChildren<{}>) {
  return (
    <Wizard>
      <Provider>{p.children}</Provider>
    </Wizard>
  );
}

export const IssueCreateContext =
  createContext<ReturnType<typeof useProvider>>(null);

function Provider(p: PropsWithChildren<{}>) {
  const value = useProvider();
  return <IssueCreateContext value={value}>{p.children}</IssueCreateContext>;
}

function useProvider() {
  const [isCreating, setCreating] = useState(false);
  const [isMinimized, setMinimized] = useState(false);
  const [createdIssue, setCreatedIssue] = useState(null as IssueModel);

  const { stepJump } = useWizard();

  function toggleMinimized(force?: boolean) {
    setMinimized((c) => force ?? !c);
  }

  function begin() {
    setCreating(true);
    setMinimized(false);
    stepJump(0);
    setCreatedIssue(null);
  }

  function cancel() {
    setCreating(false);
    setCreatedIssue(null);
  }

  function create(model: IssueModel) {
    setCreating(true);
    setCreatedIssue(model);
  }

  function finish() {
    setCreating(false);
  }

  return {
    isCreating,
    isMinimized,
    createdIssue,
    begin,
    cancel,
    create,
    finish,
    toggleMinimized,
  };
}
